export default class VideosFetchConfig {

  public static readonly defaultListOffset = 0;
  public static readonly defaultMaxCount = 1000000;

  private _videoIds = new Array<string>();
  
  private _channelIds = new Array<number>(); // only use one channel!
  private _subChannels = true;

  private _allowedChannelIds = new Array<number>();

  private _searchTerms = new Array<string>();
  private _searchField: string | undefined = undefined;

  private _listOffset = VideosFetchConfig.defaultListOffset;
  private _maxCount = VideosFetchConfig.defaultMaxCount;

  public isDefault() {
    return this.channelIds.length === 0 &&
      this.videoIds.length === 0 &&
      this.subChannels === true &&
      this.searchTerms.length === 0 &&
      this.listOffset === VideosFetchConfig.defaultListOffset &&
      this.maxCount === VideosFetchConfig.defaultMaxCount;
  }

  public isFullList() {
    return this.listOffset === VideosFetchConfig.defaultListOffset &&
      this.maxCount === VideosFetchConfig.defaultMaxCount;
  }

  public get videoIds() {
    return this._videoIds;
  }
  
  public get channelIds() {
    return this._channelIds;
  }
  public get subChannels() {
    return this._subChannels;
  }
  public set subChannels(value) {
    this._subChannels = value;
  }
  public get allowedChannelIds() {
    return this._allowedChannelIds;
  }
  public set allowedChannelIds(value) {
    this._allowedChannelIds = value;
  }

  public get searchTerms() {
    return this._searchTerms;
  }
  public get searchField() {
    return this._searchField;
  }
  public set searchField(value) {
    this._searchField = value;
  }

  public get listOffset() {
    return this._listOffset;
  }
  public set listOffset(value) {
    this._listOffset = value;
  }
  public get maxCount() {
    return this._maxCount;
  }
  public set maxCount(value) {
    this._maxCount = value;
  }
}